import { NARRATIVE_MESSAGES_KO_V0 } from '@shared/genesis-home-capability-narrative/messages-ko';
import type { RequiredTranslationKeyV0 } from './catalog';

export const KO_KR_MESSAGES_V0: Record<RequiredTranslationKeyV0, string> = {
  ...NARRATIVE_MESSAGES_KO_V0,
  'common.appName': 'Inflomatrix',
  'common.loading': '불러오는 중…',
  'common.save': '저장',
  'common.cancel': '취소',
  'common.close': '닫기',
  'common.language': '언어',
  'common.languageDescription': '사용자 인터페이스 언어를 선택합니다. 통화·시간대와는 별개입니다.',

  'navigation.today': '오늘',
  'navigation.workbench': '워크벤치',
  'navigation.operations': '업무',
  'navigation.objects': '객체',
  'navigation.evidenceDecisions': '증빙·결정',
  'navigation.peopleAuthority': '사람·권한',
  'navigation.automation': '자동화',
  'navigation.configure': '구성',
  'navigation.operationsConsole': '운영 콘솔',

  'states.operation.DRAFT': '초안',
  'states.operation.PROPOSED': '제안됨',
  'states.operation.READY': '준비됨',
  'states.operation.ADMITTED': '수락됨',
  'states.operation.RUNNING': '실행 중',
  'states.operation.WAITING': '대기',
  'states.operation.NEEDS_ATTENTION': '주의 필요',
  'states.operation.BLOCKED': '차단됨',
  'states.operation.DENIED': '거부됨',
  'states.operation.FAILED': '실패',
  'states.operation.COMPENSATING': '보정 중',
  'states.operation.COMPLETED': '완료',
  'states.operation.CANCELLED': '취소됨',
  'states.evidence.SUBMITTED': '제출됨',
  'states.evidence.REVIEWED': '검토됨',
  'states.evidence.ACCEPTED': '수락됨',
  'states.evidence.SATISFIED': '충족됨',
  'states.evidence.REJECTED': '반려됨',
  'states.authority.PENDING': '권한 대기',
  'states.authority.GRANTED': '권한 부여됨',
  'states.authority.DENIED': '권한 거부됨',
  'states.sync.SCAN_OK': '스캔 성공',
  'states.sync.LOADING': '동기화 중',
  'states.recovery.AVAILABLE': '복구 가능',
  'states.ai.PROPOSED': 'AI 제안',
  'states.ai.ADMITTED': '시스템 수락',
  'states.task.READY': '할 일 준비',
  'states.task.IN_PROGRESS': '할 일 진행 중',
  'states.task.DONE': '할 일 완료',

  'actions.review': '검토',
  'actions.provideInformation': '정보 제공',
  'actions.requestExecution': '실행 요청',
  'actions.approve': '승인',
  'actions.deny': '거부',
  'actions.start': '시작',
  'actions.resume': '재개',
  'actions.retry': '다시 시도',
  'actions.cancel': '취소',
  'actions.requestCompensation': '보정 요청',
  'actions.openRecovery': '복구 열기',
  'actions.viewReceipt': '영수증 보기',

  'errors.execution.receivingQuantityMissing.whatHappened': '실행되지 않았습니다.',
  'errors.execution.receivingQuantityMissing.why': '필요한 입고 수량이 입력되지 않았습니다.',
  'errors.execution.receivingQuantityMissing.whatChanged': '재고에는 변경이 없습니다.',
  'errors.execution.receivingQuantityMissing.whatDidNotChange':
    '다른 업무 기록도 변경되지 않았습니다.',
  'errors.execution.receivingQuantityMissing.nextAction':
    '수량을 입력한 뒤 다시 요청할 수 있습니다.',
  'errors.shell.loadFailure.whatHappened': '페이지를 불러오지 못했습니다.',
  'errors.shell.loadFailure.why': '응답을 해석할 수 없거나 네트워크 오류가 발생했습니다.',
  'errors.shell.loadFailure.whatChanged': '화면에 표시할 데이터가 갱신되지 않았습니다.',
  'errors.shell.loadFailure.whatDidNotChange':
    '서버의 업무 데이터·권한·증빙 상태는 변경되지 않았습니다.',
  'errors.shell.loadFailure.nextAction': '다시 시도하거나 복구 경로로 이동할 수 있습니다.',

  'today.title': '오늘',
  'today.subtitle': '지금 주의가 필요한 업무',
  'today.attention': '주의 항목',
  'workbench.title': '워크벤치',
  'workbench.subtitle': '하나의 통제된 실행',
  'workbench.stage.request': '요청',
  'workbench.stage.intent': '의도',
  'workbench.stage.operation': '업무',
  'workbench.stage.authority': '권한',
  'workbench.stage.evidence': '증빙',
  'workbench.stage.execution': '실행',
  'workbench.stage.result': '결과',
  'workbench.stage.recovery': '복구',
  'genesis.title': 'Genesis',
  'genesis.stage.start': '시작',
  'genesis.stage.sources': '소스',
  'genesis.stage.facts': '사실',
  'genesis.stage.proposals': '제안',
  'genesis.stage.preview': '구성 미리보기',
  'genesis.stage.generate': '생성',
  'genesis.stage.firstOperation': '첫 업무',
  'evidence.title': '증빙·결정',
  'evidence.needsReview': '검토 필요',
  'evidence.historyTitle': '증빙·결정 이력',
  'evidence.historySubtitle': '완료된 검토·결정 기록',
  'authority.title': '권한',
  'auth.login': '로그인',
  'auth.logout': '로그아웃',
  'settings.personalLanguage': '언어',
  'settings.tenantDefaultLanguage': '기본 언어',
  'settings.tenantDefaultLanguageHelp':
    '개인 언어 설정이 없는 사용자에게만 적용됩니다. 기존 개인 설정은 덮어쓰지 않습니다.',
  'public.home': '홈',
  'public.product': '제품',
  'public.language': '언어',
  'public.intake.submitFailed.whatHappened': '접수를 완료하지 못했습니다',
  'public.intake.submitFailed.why': '문의·주문 접수 API 호출에 실패했거나 응답이 거절되었습니다.',
  'public.intake.submitFailed.whatChanged':
    '이 화면에 오류 상태가 표시되었습니다. 서버에 새 접수가 생성되지 않았을 수 있습니다.',
  'public.intake.submitFailed.whatDidNotChange':
    '기존 접수·주문·권한·세션은 이 실패로 변경되지 않았습니다.',
  'public.intake.submitFailed.nextAction': '내용을 확인한 뒤 다시 시도해 주세요.',
  'public.intake.waitingReason': '접수를 처리하는 중입니다. 완료될 때까지 기다려 주세요.',
  'public.intake.waitingRequired': '접수 API 응답',
  'public.intake.receipt.areaLabel': '공개 접수',
  'public.intake.receipt.whatChanged': '접수가 수락(accepted)되어 검토 대기열에 올랐습니다.',
  'public.intake.receipt.whatDidNotChange': '실행(executed)되지 않았습니다. 수락 ≠ 실행입니다.',
  'public.receipt.orderReceived': '주문 접수됨',
  'public.receipt.requestReceived': '요청 접수됨',
  'public.receipt.qty': '수량',
  'public.receipt.total': '합계',
  'public.receipt.submitted': '접수일',
  'public.receipt.acceptedNotExecuted': '수락됨(accepted) — 아직 실행(executed)되지 않음',
  'public.actionError.PARENT_NOT_FOUND': '원본 접수를 찾을 수 없습니다.',
  'public.actionError.PARENT_SCOPE_MISMATCH': '이 접수에 대한 권한이 없습니다.',
  'public.actionError.ACTION_NOT_ALLOWED': '현재 상태에서는 이 요청을 할 수 없습니다.',
  'public.actionError.DUPLICATE_ACTION': '이미 처리 중인 동일 요청이 있습니다.',
  'public.actionError.VALIDATION_FAILED': '입력 내용을 확인해 주세요.',
  'public.actionError.POLICY_NOT_FOUND': '요청 정책을 찾을 수 없습니다.',
  'public.actionError.fallback': '요청 제출에 실패했습니다. 잠시 후 다시 시도해 주세요.',
  'public.actionError.disabled': '현재 이 요청을 할 수 없습니다.',
  'public.actionError.successAccepted':
    '요청이 접수(accepted)되었습니다. 아직 실행(executed)되지 않았습니다.',
  'public.actionError.failure.whatHappened': '후속 요청을 제출하지 못했습니다',
  'public.actionError.failure.whatChanged':
    '이 화면에 오류가 표시되었습니다. 후속 요청이 생성되지 않았을 수 있습니다.',
  'public.actionError.failure.whatDidNotChange':
    '원본 접수·실행 상태·권한은 이 실패로 변경되지 않았습니다.',
  'public.actionError.failure.nextAction':
    '사유를 확인한 뒤 다시 시도하거나 지원 참조와 함께 문의해 주세요.',
  'legal.privacy': '개인정보 처리방침',
  'legal.terms': '이용약관',
  'portal.gateway': '포털',
  'configure.title': '구성',
  'console.title': '운영 콘솔',
  'operations.title': '업무',
  'operations.subtitle': '업무 유형·실행·예외를 관리합니다',
  'objects.title': '객체',
  'objects.subtitle': '운영 객체 맥락과 관련 업무',
  'people.title': '사람·권한',
  'automation.title': '자동화',
  'decisions.title': '결정',
};
